import React from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import {
    LogoutOutlined,
    ProfileOutlined,
    RollbackOutlined,
    SettingOutlined,
} from '@ant-design/icons';
import { useTheme } from 'styled-components';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../services/firebase';
import date from '../../../helpers/date';
import {
    PresentationMenu,
    StyledMenu,
    StyledMenuItem,
    StyledMenuDivider,
    StyledMenuItemVersion,
} from './styles';
// contexts
import { useAuth } from '../../../contexts/Auth';
import { getLabelRoles, EnRoles } from '../../../interfaces/Roles';

interface IProps {
    setVisible: (value: boolean) => void;
}

const APP_VERSION_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180; // 180 dias

const AvatarDropDownMenu: React.FC<IProps> = ({ setVisible }) => {
    function handleMenuClick() {
        setVisible(false);
    }
    const navigate = useNavigate();

    const { logOut, data } = useAuth();

    const { theme, colors } = useTheme();

    const getMenuProps = (pathname: string) => {
        return {
            key: '3',
            onClick: () => {
                if (!data.user) {
                    navigate('/login');
                    return;
                }
                navigate(pathname);
            },
        };
    };

    const handleLogOut = () => {
        logOut();
        setVisible(false);
        navigate('/login');
        message.success('Você saiu do sistema');
    };

    const handleToSettings = () => {
        navigate('/settings');
    };

    const handleBackToPreviousVersion = () => {
        logEvent(analytics, 'back_to_previous_version');

        const secureAttr =
            window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `app_version=v1; path=/; max-age=${APP_VERSION_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secureAttr}`;
        setVisible(false);
        window.location.reload();
    };

    const isSuperUser = React.useMemo(() => {
        if (data?.role?.length > 0 && data.role[0]?.type === EnRoles.sysAdmin) {
            return true;
        }
        return false;
    }, [data]);

    return (
        <StyledMenu
            subMenuCloseDelay={0.5}
            subMenuOpenDelay={0.5}
            onClick={() => handleMenuClick}
            selectable={false}
        >
            <StyledMenu.ItemGroup key="0">
                <PresentationMenu>
                    <p
                        style={{
                            color:
                                theme === 'light' ? colors.lightFont : '#fff',
                        }}
                    >
                        <strong>Olá, {data?.user?.email}</strong>
                    </p>
                    <p>
                        <strong>Função:</strong>
                        {getLabelRoles(data?.role?.[0]?.type)}
                    </p>
                </PresentationMenu>
            </StyledMenu.ItemGroup>
            <StyledMenuDivider />
            {/* <StyledMenu.ItemGroup key="1">
                <PresentationMenu>
                    <p>
                        <strong>E-mail:</strong> email@email.com
                    </p>
                    <p>
                        <strong>phone:</strong> --------
                    </p>
                </PresentationMenu>
            </StyledMenu.ItemGroup> */}
            <StyledMenuDivider />
            {/* <StyledMenuItem key="2" icon={<SettingOutlined />}>
                Editar perfil
            </StyledMenuItem>
            <StyledMenuDivider /> */}
            <StyledMenuItem
                icon={<ProfileOutlined />}
                {...getMenuProps('/users/data')}
            >
                Minha Conta
            </StyledMenuItem>
            <StyledMenuDivider />
            <StyledMenuItem
                onClickCapture={handleBackToPreviousVersion}
                key="8"
                icon={<RollbackOutlined />}
            >
                Voltar para versão anterior
            </StyledMenuItem>
            <StyledMenuDivider />
            {isSuperUser && (
                <StyledMenuItem
                    onClickCapture={handleToSettings}
                    key="9"
                    icon={<SettingOutlined />}
                >
                    Configurações
                </StyledMenuItem>
            )}
            <StyledMenuDivider />
            <StyledMenuItem
                onClickCapture={handleLogOut}
                key="4"
                icon={<LogoutOutlined />}
            >
                Sair
            </StyledMenuItem>
            <StyledMenuItemVersion disabled key="5">
                <div
                    style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                >
                    <span>Versão: {import.meta.env.VITE_VERSION_CODE || '0.0.0-local'}</span>
                    <span>
                        Publicação: {date(import.meta.env.VITE_VERSION_DATE || 0).format('lll')}
                    </span>
                </div>
            </StyledMenuItemVersion>
        </StyledMenu>
    );
};

export default AvatarDropDownMenu;
